export default import.meta.ROLLUP_FILE_URL_DUA2tiisjIeXzZF24PX2uA;